import { EclesialElementValidationComponent } from '@app/base/component/eclesial/eclesial.element.validation.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EclesialSelectComponent } from '../component/eclesial/eclesial.select.component';
import { EclesialInputComponent } from '../component/eclesial/eclesial.input.component';
import { LimitToDirective } from '../directives/limitto.directive';
import { EclesialInputNumberComponent } from '../component/eclesial/eclesial.input.number.component';
import { AgGridModule } from 'ag-grid-angular';
import { AgGridPaginationComponent } from '@app/features/ag-grid-pagination/component/ag-grid-pagination.component';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { NumberOnlyDirective } from '../directives/numberonly.directive';
import { LoaderSpinComponent } from '@app/features/loader-spin/loader-spin.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        AgGridModule.withComponents([]),
        DeviceDetectorModule.forRoot(),
    ],
    declarations: [
        EclesialSelectComponent,
        EclesialElementValidationComponent,
        EclesialInputComponent,
        LimitToDirective,
        EclesialInputNumberComponent,
        AgGridPaginationComponent,
        NumberOnlyDirective,
        LoaderSpinComponent,
    ],
    exports: [
        EclesialSelectComponent,
        EclesialElementValidationComponent,
        EclesialInputComponent,
        LimitToDirective,
        EclesialInputNumberComponent,
        AgGridPaginationComponent,
        NumberOnlyDirective,
        LoaderSpinComponent,
    ],
    providers: [
    ],
})
export class SharedEclesialComponentModule { }
